import React from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import methodsimg from "../../public/images/aboutcorporatebg.gif";

const AboutCorporate = () => {
  return (
    <div className='bg-[#ecebeb58] '>
      <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 '>
        <div className='grid grid-cols-1 lg:grid-cols-2 lg:gap-14 lg:py-12 py-9 '>
          <div className='flex justify-end items-center'>
            <Image src={methodsimg} alt='placement portal'
              unoptimized={true} />
          </div>
          <div className=''>
            <motion.h2
             initial={{ opacity: 0, scale: 0.5 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5 }}
            className='font-bold lg:text-3xl text-xl text-[#41b5ee]'>WHO WE ARE?</motion.h2>
            <p className='py-1 lg:text-4xl text-xl font-bold lg:leading-[45PX]'>Lead the way with trust, reliability, and excellence for our stakeholders</p>
            <p className='py-1 lg:text-[40px] text-lg lg:leading-[47px] tracking-[1px] font-extralight'>We are your trusted solution partner leading the way in virtual campus drives with our<span className='font-semibold'> end-to-end tech-enabled platform.</span> Our deep industry expertise and unwavering commitment ensure your business not only survives but thrives.</p>
            <p className='lg:text-[22px] text-lg'>Specializing in software solutions, we embrace innovation and harness the power of cutting-edge technology to drive positive impact worldwide. As a startup bridging IT expertise with business acumen, we transform ideas into top-tier software solutions using advanced processes and the latest technologies.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutCorporate